export default __webpack_public_path__ + "static/media/Measure_Black.efa1c8ab.webp";